<div class="side-filters">
  <ng-container *ngIf="mode === 'sites'; else channelsMode">
    <ng-container *ngIf="singleChoice; else selectAllSitesTemplateRef">
      <mat-checkbox
        [ngClass]="selectionMode"
        [checked]="!siteGroupsSet.size && !sitesSet.size"
        (change)="toggleAllSites({ checked: false })">
        <strong>{{ 'all-accounts' | translate }}</strong>
      </mat-checkbox>
    </ng-container>

    <ng-template #selectAllSitesTemplateRef>
      <mat-checkbox
        [checked]="siteGroupsSet.size === siteGroups.length && sitesSet.size === sites.length"
        (change)="toggleAllSites($event)">
        <strong>{{ 'all-accounts' | translate }}</strong>
      </mat-checkbox>
    </ng-template>

    <mat-checkbox
      *ngFor="let item of siteGroups"
      [ngClass]="selectionMode"
      [checked]="siteGroupsSet.has(item.id)"
      (change)="toggleSiteGroup(item.id, $event)">
      <app-site-icon-and-name [item]="item" [tooltipLabel]="item?.name">{{ item?.name }}</app-site-icon-and-name>
    </mat-checkbox>
    <mat-checkbox
      *ngFor="let item of sites"
      [ngClass]="selectionMode"
      [checked]="sitesSet.has(item.id)"
      (change)="toggleSite(item.id, $event)">
      <app-site-icon-and-name [item]="item" [tooltipLabel]="item?.name">{{ item?.name }}</app-site-icon-and-name>
    </mat-checkbox>
  </ng-container>
  <ng-template #channelsMode>
    <ng-container *ngIf="singleChoice; else selectAllChannelsTemplateRef">
      <mat-checkbox
        [ngClass]="selectionMode"
        [checked]="!siteGroupsSet.size && !sitesSet.size"
        (change)="toggleAllChannels({ checked: false })">
        <strong>{{ 'all-channels' | translate }}</strong>
      </mat-checkbox>
    </ng-container>

    <ng-template #selectAllChannelsTemplateRef>
      <mat-checkbox [checked]="channelsSet.size === channels.length" (change)="toggleAllChannels($event)">
        <strong>{{ 'all-channels' | translate }}</strong>
      </mat-checkbox>
    </ng-template>

    <mat-checkbox
      *ngFor="let channel of channels"
      [ngClass]="selectionMode"
      [checked]="channelsSet.has(channel.id)"
      (change)="toggleChannel(channel.id, $event)">
      <app-site-icon-and-name [item]="channel" [tooltipLabel]="channel?.label">{{
        channel?.label
      }}</app-site-icon-and-name>
    </mat-checkbox>
  </ng-template>
</div>
<div class="content-wrapper">
  <ng-content></ng-content>
</div>
